import { render, staticRenderFns } from "./index--module-card.vue?vue&type=template&id=3a10ba76&scoped=true&"
import script from "./index--module-card.vue?vue&type=script&lang=js&"
export * from "./index--module-card.vue?vue&type=script&lang=js&"
import style0 from "./index--module-card.vue?vue&type=style&index=0&id=3a10ba76&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a10ba76",
  null
  
)

export default component.exports